// carousel-banner.js
document.addEventListener('DOMContentLoaded', function() {
  const carouselWrapper = document.querySelector('.carousel-wrapper');
  const carouselItems = document.querySelectorAll('.carousel-item');
  const prevButton = document.querySelector('.carousel-prev');
  const nextButton = document.querySelector('.carousel-next');
  
  let currentIndex = 0;
  const totalItems = carouselItems.length;
  const itemsToShow = 3;

  function updateCarousel() {
    const offset = currentIndex * (100 / itemsToShow);
    carouselWrapper.style.transform = `translateX(-${offset}%)`;
  }

  prevButton.addEventListener('click', function() {
    if (currentIndex > 0) {
      currentIndex--;
    } else {
      currentIndex = totalItems - itemsToShow;
    }
    updateCarousel();
  });

  nextButton.addEventListener('click', function() {
    if (currentIndex < totalItems - itemsToShow) {
      currentIndex++;
    } else {
      currentIndex = 0;
    }
    updateCarousel();
  });

  updateCarousel();
});